import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErroreApi } from './api/cliente.js';
import { router } from './router.js';
import './stili/caratteri.css';
import './stili/base.css';
import './stili/rotta.css';
import './stili/ordini.css';
import './stili/accesso.css';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // Chi lavora otto ore di fila non deve vedere la pagina ricaricarsi da
      // sola a ogni cambio di finestra: si aggiorna quando serve, non sempre.
      refetchOnWindowFocus: false,
      // un errore nella richiesta (un indirizzo sbagliato, un numero che non
      // esiste) non si aggiusta riprovando: si dice subito
      retry: (volte, errore) => !(errore instanceof ErroreApi && errore.stato < 500) && volte < 1,
      staleTime: 30_000,
    },
  },
});

const radice = document.getElementById('radice');
if (!radice) throw new Error('Manca il contenitore #radice in index.html');

createRoot(radice).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);

/**
 * Il guscio da installare sul telefono.
 *
 * Solo nella versione costruita: in sviluppo il ricaricamento a caldo e un
 * service worker che serve file dal deposito si danno fastidio a vicenda, e
 * si passano ore a capire perché una modifica non compare.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/service-worker.js');
  });
}
